import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AvatarModule } from 'src/app/ui/components/avatar/avatar.module';

import { LogoModule } from '../../../components/logo/logo.module';
import { AvatarSidebarCellComponent } from './components/avatar-sidebar-cell/avatar-sidebar-cell.component';
import { SidebarCellComponent } from './components/sidebar-cell/sidebar-cell.component';
import { SidebarComponent } from './sidebar.component';

@NgModule({
  declarations: [
    SidebarComponent,
    SidebarCellComponent,
    AvatarSidebarCellComponent,
  ],
  exports: [SidebarComponent],
  imports: [CommonModule, AvatarModule, LogoModule],
})
export class SidebarModule {}
